import React from 'react';
import { ActiveOrders, useActiveOrders } from '@thd-olt-component-react/active-orders';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ViewAllOrdersFooter } from '../snapshot-tab-view/ViewAllOrdersFooter';

/**
 * Not exported: the body lives here so ActiveOrdersCard can wrap it in an ErrorBoundary,
 * matching LatestOrdersCard.
 *
 * ActiveOrders renders no header in Dashboard Snapshot mode, and its own "View All" is
 * disabled upstream (OOP-4207), so the tab's "View All Orders (N)" footer comes from here —
 * the same footer, destination and analytics LatestOrdersCard uses, so the action follows
 * the feature switch rather than disappearing with it. useActiveOrders is called with
 * ActiveOrders' own default paging, so it asks for the same `activeOrders` query.
 */
const ActiveOrdersPanel = () => {
  const { data, loading, error } = useActiveOrders();
  const count = data?.totalCardCount ?? data?.activeDistributions?.length ?? 0;

  // Matches LatestOrdersCard: only shown once real orders have loaded, not during
  // loading/error/empty, which ActiveOrders covers with its own states.
  const showViewAllOrders = !loading && !error && count > 0;

  return (
    <>
      <ActiveOrders componentLocation="dashboard-snapshot" isDashboardSnapshot />
      {showViewAllOrders && <ViewAllOrdersFooter count={count} testId="active-orders-view-all" />}
    </>
  );
};

/**
 * The "Active Deliveries & Pickups" tab, shown instead of Your Latest Orders when the
 * Active Orders feature switch is on. ActiveOrders owns its own query, loading/error/
 * empty states, and carousel, so this wrapper supplies the tab's error boundary, the
 * componentLocation for analytics, and the View All Orders footer.
 */
export const ActiveOrdersCard = () => (
  <ErrorBoundary name="dashboard-snapshot-active-orders">
    <ActiveOrdersPanel />
  </ErrorBoundary>
);

ActiveOrdersCard.displayName = 'ActiveOrdersCard';
ActiveOrdersCard.dataModel = ActiveOrders.dataModel;
